import React, { Fragment } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ENVIRONMENTS, REGIONS_DATASOURCE } from '../../Constants/constants';
import { InputSwitch } from 'primereact/inputswitch';

export default function TestConfigPanel({
  testConfig,
  onChangeTestConfig,
  env,
  setEnv,
  isEditMode,
  isDuplicate,
  isLimitUrls,
  onSaveEdited,
  saveDuplicateHandler,
  onSubmit,
  onScan,
}) {
  return (
    <Fragment>
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: 'auto' }}>
          {isEditMode || isDuplicate ? (
            <Button
              disabled={isLimitUrls}
              onClick={isEditMode ? onSaveEdited : saveDuplicateHandler}
              label='Save'
            />
          ) : testConfig.scan ? (
            <Button disabled={isLimitUrls} onClick={onScan} label='Scan' />
          ) : (
            <Button
              disabled={isLimitUrls}
              onClick={onSubmit}
              label='Run Test'
            />
          )}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          marginBottom: '15px',
          gap: '15px',
        }}
      >
        <div>
          <Dropdown
            options={ENVIRONMENTS}
            value={env}
            onChange={(e) => setEnv(e.value)}
            optionLabel='text'
            optionValue='value'
            placeholder='Environment'
            style={{ width: '250px' }}
          />
        </div>
        <div>
          <Dropdown
            options={REGIONS_DATASOURCE}
            value={testConfig.region}
            onChange={(e) => onChangeTestConfig('region', e.value)}
            optionLabel='text'
            optionValue='value'
            placeholder='Region'
            style={{ width: '250px' }}
          />
        </div>
        <div
          className='p-field-checkbox'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <InputSwitch
            checked={testConfig.executionType === 'regression'}
            onChange={(e) =>
              onChangeTestConfig(
                'executionType',
                e.value ? 'regression' : 'standard'
              )
            }
            className='mr-2'
          />
          <label htmlFor='executionTypeSwitch'>Regression</label>
        </div>
        <div
          className='p-field-checkbox'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <InputSwitch
            checked={testConfig.smokeTest}
            onChange={(e) => onChangeTestConfig('smokeTest', e.value)}
            className='mr-2'
          />
          <label htmlFor='smokeTest'>Smoke Test</label>
        </div>
        <div
          className='p-field-checkbox'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <InputSwitch
            checked={testConfig.includeTracking}
            onChange={(e) => onChangeTestConfig('includeTracking', e.value)}
            className='mr-2'
          />
          <label htmlFor='includeTracking'>Include Tracking</label>
        </div>
        {/* InputSwitch for scan functionality */}
        {/* <div
          className='p-field-checkbox'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <InputSwitch
            checked={testConfig.scan}
            onChange={(e) => onChangeTestConfig('scan', e.value)}
            className='mr-2'
          />
          <label htmlFor='scan'>Scan Urls</label>
        </div> */}
      </div>
      <div style={{ display: 'flex', marginBottom: '15px' }}>
        <div>
          <InputText
            className='tests-execution-name-textbox w-full'
            placeholder='Enter the test execution name'
            value={testConfig.name}
            onChange={(e) => onChangeTestConfig('name', e.target.value)}
            style={{ width: '250px', marginRight: '15px' }}
          />
          <small id='errroForTestExecutionName' className='p-error block' />
        </div>
        <InputText
          className='tests-execution-description-textbox w-full'
          placeholder='Enter the test execution description'
          value={testConfig.description}
          onChange={(e) => onChangeTestConfig('description', e.target.value)}
          style={{ width: '100%' }}
        />
        <small
          id='errorForTestExecutionDescription'
          className='p-error block'
        />
      </div>
    </Fragment>
  );
}
